// Shared 8D / quality model used by BOTH customer and supplier complaints.
// Canonical step keys d0..d8. `legacy` maps to the flat customer-complaint fields.
export const D_STEPS = [
  { key: "d0", label: "D0 – Sofortmaßnahme", legacy: "d0_immediate" },
  { key: "d1", label: "D1 – Team", legacy: "d1_team" },
  { key: "d2", label: "D2 – Problembeschreibung", legacy: "d2_problem" },
  { key: "d3", label: "D3 – Sofortmaßnahmen (Containment)", legacy: "d3_containment" },
  { key: "d4", label: "D4 – Ursachenanalyse", legacy: "d4_root_cause" },
  { key: "d5", label: "D5 – Korrekturmaßnahmen", legacy: "d5_corrective" },
  { key: "d6", label: "D6 – Umsetzung", legacy: "d6_implementation" },
  { key: "d7", label: "D7 – Vorbeugung", legacy: "d7_prevention" },
  { key: "d8", label: "D8 – Abschluss & Anerkennung", legacy: "d8_closure" },
];

export const FIVE_WHY_STEP = "d4";

export const ISHIKAWA_CATS = [
  { key: "man", label: "Mensch" },
  { key: "machine", label: "Maschine" },
  { key: "method", label: "Methode" },
  { key: "material", label: "Material" },
  { key: "measurement", label: "Messung" },
  { key: "environment", label: "Umwelt" },
];

export const CAPA_TYPES = [
  { key: "corrective", label: "Korrektur" },
  { key: "preventive", label: "Vorbeuge" },
];

export const CAPA_STATUS = {
  open: ["bg-gray-100 text-gray-700", "Offen"],
  in_progress: ["bg-amber-100 text-amber-800", "In Arbeit"],
  done: ["bg-emerald-100 text-emerald-700", "Erledigt"],
};

export function progress8d(value, steps = D_STEPS) {
  const done = steps.filter((s) => value?.[s.key]?.done).length;
  const total = steps.length;
  return { done, total, pct: total ? Math.round((done / total) * 100) : 0 };
}

// Maturity badge derived from step completion.
export function maturity(value, steps = D_STEPS) {
  const { done, total } = progress8d(value, steps);
  if (done === 0) return { key: "draft", label: "Entwurf", cls: "bg-slate-100 text-slate-600" };
  if (done >= total) return { key: "complete", label: "Abgeschlossen", cls: "bg-emerald-100 text-emerald-700" };
  return { key: "in_progress", label: "In Bearbeitung", cls: "bg-blue-100 text-blue-700" };
}

export function isOverdue(due, status) {
  if (!due || status === "done") return false;
  try { return new Date(due) < new Date(new Date().toDateString()); } catch { return false; }
}
